import type { DocumentoAmbito, DocumentosConfig } from "@/types";

export const AMBITO_LABELS: Record<DocumentoAmbito, string> = {
  empresa: "Empresa",
  licitacion: "Licitación",
};

/** Subcarpetas por defecto: espejo de la lista fija validada en backend. */
export const SUBCARPETAS: Record<DocumentoAmbito, string[]> = {
  empresa: ["legal", "financiero", "garantias", "certificaciones"],
  licitacion: ["bases-anexos", "aclaraciones", "propuesta", "contrato-garantias"],
};

export const SUBCARPETA_LABELS: Record<string, string> = {
  legal: "Legal",
  financiero: "Financiero",
  garantias: "Garantías",
  certificaciones: "Certificaciones",
  "bases-anexos": "Bases y anexos",
  aclaraciones: "Aclaraciones",
  propuesta: "Propuesta",
  "contrato-garantias": "Contrato y garantías",
};

export const DEFAULT_DOCUMENTOS_CONFIG: DocumentosConfig = {
  storageEnabled: false,
  provider: "noop",
  maxFileBytes: 25 * 1024 * 1024,
  allowedMime: [],
  subcarpetas: SUBCARPETAS,
  subcarpetaLabels: SUBCARPETA_LABELS,
};

export function subcarpetaLabel(config: DocumentosConfig, value: string): string {
  return config.subcarpetaLabels[value] ?? SUBCARPETA_LABELS[value] ?? value;
}

export function formatBytes(bytes?: number | null): string {
  if (!bytes || bytes <= 0) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

export function formatRelative(value?: string | null): string {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const diff = Date.now() - date.getTime();
  const minutes = Math.round(diff / 60_000);
  if (minutes < 1) return "recién";
  if (minutes < 60) return `hace ${minutes} min`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `hace ${hours} h`;
  const days = Math.round(hours / 24);
  if (days < 30) return `hace ${days} d`;
  return date.toLocaleDateString("es-CL");
}

/** Días restantes de vigencia; negativo si ya venció. */
export function diasParaVencer(vigenciaHasta?: string | null): number | null {
  if (!vigenciaHasta) return null;
  const date = new Date(vigenciaHasta);
  if (Number.isNaN(date.getTime())) return null;
  return Math.ceil((date.getTime() - Date.now()) / 86_400_000);
}
